import { LocaleUtilType } from "UidispatcherApiModule";
const { LocaleUtil }: { LocaleUtil: LocaleUtilType } =
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default LocaleUtil;
